<template>
  <b-modal :id="id" :title="$t('dharma-application-form.message.application-completed.title')" centered>
    <p>{{ $t('dharma-application-form.message.application-completed.content[0]') }}</p>
    <p>{{ $t('dharma-application-form.message.application-completed.content[1]') }}</p>
    <p>
      {{ $t('dharma-application-form.message.application-completed.content[2]') }}
      <a :href="`mailto: ${contact_email_address}`">{{ contact_email_address }}</a>
    </p>
    <p v-if="contact_extension_number">
      {{ $t('dharma-application-form.message.application-completed.content[3]') }}
      <a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198</a>
      {{ $t('dharma-application-form.message.application-completed.content[4]') }}
      {{ contact_extension_number }}
    </p>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.complete.label') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'application-complete-message-modal',
  props: {
    id: { type: String, required: true },
    contact_email_address: { type: String, default: '' },
    contact_extension_number: { type: String, default: '' }
  },
  methods: {
    // 
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  }
}
</script>